import styled from 'styled-components';

export const Wrapper = styled.label`
  display: inline-flex;
  align-items: center;
  height: 1.6em;
  position: relative;
  font-size: 85%;

  .switch-input {
    display: none;

    &:checked + .el-switch-style {
      background-color: #791ace;

      &:before {
        left: 50%;
      }
    }
  }

  .el-switch-style {
    position: relative;
    top: 0;
    left: 0;
    display: inline-block;
    width: 3em;
    height: 1.6em;
    background: #c0ccda;
    border-radius: 0.8em;
    transition: all 0.3s ease-in-out;
    cursor: pointer;

    &:before {
      display: block;
      content: '';
      height: 1.4em;
      position: absolute;
      width: 1.4em;
      background-color: #fff;
      border-radius: 50%;
      left: 0.1em;
      top: 0.1em;
      transition: all 0.3s ease-in-out;
    }
  }
`;
